import { createContext, useContext } from "react";
import { useWindows } from "../hooks/useWindows";

const WindowContext = createContext(null);

export const WindowProvider = ({ children }) => {
  const value = useWindows();

  return (
    <WindowContext.Provider value={value}>{children}</WindowContext.Provider>
  );
};

export const useWindowManager = () => {
  const context = useContext(WindowContext);

  if (!context) {
    throw new Error("useWindowManager must be used within WindowProvider");
  }

  return context;
};
